import { inject, Injectable } from '@angular/core';
import { HardNavigationService } from '@rma/generic/util/posthog';

@Injectable({
  providedIn: 'root',
})
export class LoginPathsService {
  private readonly hardNavigation = inject(HardNavigationService);

  public goToLogin(): void {
    this.hardNavigation.assign(this.getLoginPath());
  }

  public goToClaim(): void {
    this.hardNavigation.assign(this.getClaimPath());
  }

  public goToSignUp(): void {
    this.hardNavigation.assign(this.getSignUpPath());
  }

  public getLoginPath(): string {
    return `/account/login${this.getQueryString()}`;
  }

  private getSignUpPath(): string {
    return `/account/signup${this.getQueryString()}`;
  }

  private getClaimPath(): string {
    return `/search-profile${this.getQueryString()}`;
  }

  private getQueryString(): string {
    const redirect = window.location.pathname + window.location.search;
    return `?redirectUrl=${encodeURIComponent(redirect)}`;
  }
}
